// biome-ignore lint/style/noRestrictedImports: encapsulation
import { isDeepEqual as isDeepEqual_ } from "remeda";

import type { NeverFunc } from "./_never-func";
import { unpurry } from "./_unpurry";

export const isDeepEqual = unpurry(isDeepEqual_, 2) as typeof isDeepEqual_ & NeverFunc;
